"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingTop = exports.getLabelAndDates = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var Date_1 = require("../Date");
var getLabelAndDates = function (shipment, config) {
    if (shipment.status === 'completed') {
        return {
            label: config.text.completedCTA,
            dates: shipment.completed_at ? [new Date(shipment.completed_at)] : null,
        };
    }
    if (shipment.status === 'cancelled') {
        return {
            label: config.text.cancelledMessage,
            // TODO: maybe we want to check for cancelled_at here?
            dates: null,
        };
    }
    var start = shipment.delivery_start != null ? new Date(shipment.delivery_start) : null;
    var end = shipment.delivery_end != null ? new Date(shipment.delivery_end) : null;
    if (start == null && end == null) {
        return {
            label: config.text.checkBackLater,
            dates: null,
        };
    }
    if (start != null && end != null) {
        if (start.toDateString() === end.toDateString()) {
            return {
                label: config.text.inTransitCTAOnLabel,
                dates: [start],
            };
        }
        return {
            label: config.text.inTransitCTABetweenLabel,
            dates: [start, end],
        };
    }
    if (start == null && end != null) {
        return {
            label: config.text.inTransitCTABeforeLabel,
            dates: [end],
        };
    }
    if (start != null && end == null) {
        return {
            label: config.text.inTransitCTAAfterLabel,
            dates: [start],
        };
    }
    return {
        label: config.text.checkBackLater,
        dates: null,
    };
};
exports.getLabelAndDates = getLabelAndDates;
var TrackingTop = function (_a) {
    var shipment = _a.shipment, config = _a.config;
    var _b = (0, exports.getLabelAndDates)(shipment, config), label = _b.label, dates = _b.dates;
    var parsedDates = dates === null || dates === void 0 ? void 0 : dates.map(Date_1.parseStringDate);
    return ((0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__wrapper", children: (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__top__divider", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__cta", children: (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__text", children: label }) }), parsedDates != null && parsedDates.length === 1 && ((0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__wrapper", children: (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__top__date__aligner", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__day", children: "".concat(config.text.dates.weekdays[parsedDates[0].weekday], ", ").concat(config.text.dates.months[parsedDates[0].month]) }), (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__day__numeric", children: "".concat(parsedDates[0].day).padStart(2, '0') })] }) })), parsedDates != null && parsedDates.length === 2 && ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__top__date__wrapper", children: [(0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__top__date__aligner", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__day", children: "".concat(config.text.dates.weekdays[parsedDates[0].weekday], ", ").concat(config.text.dates.months[parsedDates[0].month]) }), (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__day__numeric", children: "".concat(parsedDates[0].day).padStart(2, '0') })] }), (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__aligner", children: (0, jsx_runtime_1.jsx)("div", { class: "artajas__tracking__top__date__and", children: config.text.inTransitCTAAndLabel }) }), (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__top__date__aligner", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__day", children: "".concat(config.text.dates.weekdays[parsedDates[1].weekday], ", ").concat(config.text.dates.months[parsedDates[1].month]) }), (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__top__date__day__numeric", children: "".concat(parsedDates[1].day).padStart(2, '0') })] })] }))] }) }));
};
exports.TrackingTop = TrackingTop;
